import { SkeletonEvent, AssetType } from '../types.js';
import { NOOP } from './helpers/index.js';

function loadScript({ mfName, src, onEvent = NOOP, appendScript }) {
    const script = document.createElement('script');
    script.src = src;
    const onLoadPromise = new Promise(resolve => {
        script.onload = resolve;
    });
    script.onerror = () => {
        onEvent(SkeletonEvent.ErrorLoadingJSAsset, { mfName, src, mfResource: src });
    };
    if (appendScript) {
        appendScript(script);
    }
    else {
        document.body.appendChild(script);
    }
    return onLoadPromise;
}
function loadStylesheet({ mfName, src, onEvent = NOOP }) {
    const link = document.createElement('link');
    link.href = src;
    link.rel = 'stylesheet';
    const onLoadPromise = new Promise(resolve => {
        link.onload = resolve;
    });
    link.onerror = () => {
        onEvent(SkeletonEvent.ErrorLoadingCSSAsset, { mfName, src, mfResource: src });
    };
    document.head.appendChild(link);
    return onLoadPromise;
}
function preloadScript({ mfName, src, onEvent = NOOP, assetType = AssetType.js, appendScript }) {
    const link = document.createElement('link');
    link.href = src;
    link.rel = 'preload';
    link.as = assetType === AssetType.js ? 'script' : 'style';
    const onLoadPromise = new Promise(resolve => {
        link.onload = resolve;
    });
    link.onerror = () => {
        onEvent(assetType === AssetType.js ? SkeletonEvent.ErrorLoadingJSAsset : SkeletonEvent.ErrorLoadingCSSAsset, {
            mfName,
            src,
            mfResource: src,
        });
    };
    if (appendScript) {
        appendScript(link);
    }
    else {
        document.body.appendChild(link);
    }
    return onLoadPromise;
}

export { loadScript, loadStylesheet, preloadScript };
